// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__-ncqB","colCheckbox":"styles_colCheckbox__2MrSe"};